import { Modal, Input } from '@salecycle/ui-component-library';
import { Campaign } from 'entities/campaign';
import * as React from 'react';
import { connect } from 'react-redux';
import { Actions as RouterActions, Selectors as Router } from 'router';
import { Selectors } from 'sections/campaigns/state/campaigns';
import { cloneCampaign } from 'sections/campaigns/state/cloneCampaign';
import { State } from 'store';

interface StateProps {
  campaignId: string;
  campaign: Campaign;
}

interface DispatchProps {
  save: (id: string, name: string) => void;
  close: () => void;
}

export type Props = StateProps & DispatchProps;

export const CloneModal: React.FC<Props> = props => {
  const [name, setName] = React.useState('');

  if (!props.campaign) {
    return null;
  }

  const save = () => {
    props.save(props.campaignId, name);
  };

  return (
    <Modal
      isOpen={true}
      heading="Clone a Campaign"
      onOkButtonClicked={save}
      okButtonLabel="Save"
      okButtonDisabled={!name}
      onCancelButtonClicked={props.close}
      cancelButtonLabel="Discard"
    >
      <Input label="Campaign to Clone" ariaLabel="Campaign to Clone" disabled={true} value={props.campaign.name} />

      <Input
        label="Name"
        ariaLabel="Campaign Name"
        required={true}
        value={name}
        placeholder="Please enter a name for your new campaign"
        onChange={value => setName(value || '')}
      />
    </Modal>
  );
};

const mapState = (state: State): StateProps => {
  const campaignId = Router.getQuery(state, 'campaign_id');
  return {
    campaignId,
    campaign: Selectors.getEntity(state, campaignId),
  };
};

const actions: DispatchProps = {
  save: cloneCampaign,
  close: () => RouterActions.updateQuery({ clone: undefined, campaign_id: undefined }),
};

export default connect(mapState, actions)(CloneModal);
